const CELL_TD = "table-data";
const CELL_TH = "table-header";
const TABLE_TR = "table-row";

function createId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `table-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/** Ported from SPF TableMigrate.sanitizeNodes — normalizes legacy table cell content. */
export function sanitizeTableNodes(root: any): void {
  const traversed: Record<string, object> = {};

  const traverseNodes = (node: any = {}): void => {
    if (node?.type === CELL_TD || node?.type === CELL_TH) {
      const children = node.children || [];
      const hasElementChildren = children.some((child: any) => !!child?.type);
      if (!hasElementChildren) {
        node.children = [
          {
            type: "paragraph",
            children: children.length > 0 ? children : [{ text: "" }],
            data: { dataId: createId() },
          },
        ];
      }
    }

    if (node?.type === CELL_TD || node?.type === TABLE_TR || node?.type === CELL_TH) {
      if (!node?.data?.id || traversed[node.data.id]) {
        if (!node.data) {
          node.data = {};
        }
        node.data.id = createId();
      }
      traversed[node.data.id] = node;
    }

    const children = node?.children || [];
    if (node?.type !== CELL_TD && node?.type !== CELL_TH && children.length > 0) {
      for (let i = 0; i < children.length; i++) {
        traverseNodes(children[i]);
      }
    }
  };

  traverseNodes(root);
}
